__webpack_require__.p = "https://monitor-web-dev.quid.com/cb/web/";